import { render, staticRenderFns } from "./ClubCard.vue?vue&type=template&id=aebc6364&scoped=true"
import script from "./ClubCard.vue?vue&type=script&lang=js"
export * from "./ClubCard.vue?vue&type=script&lang=js"
import style0 from "./ClubCard.vue?vue&type=style&index=0&id=aebc6364&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aebc6364",
  null
  
)

export default component.exports